export default __webpack_public_path__ + "images/cl-b9ff305a088060fd040a79f1252e9bd8.svg";